"use client";

import React from "react";
import VocalRemoverPage from "@/components/pages/vocal-remover/vocal-remover-page";
import { VocalRemoverProgressProvider } from "@/components/pages/vocal-remover/providers/vocal-remover-progress-provider";
import MediaInputProvider from "@/providers/media-input-provider/media-input-provider";
import { vocalRemoverSessionStorage } from "@/services/storage/vocal-remover-session-storage";
import { vocalRemoverLicenseManager } from "@/services/license/license-managers/vocal-remover-license-manager";
import WavesurferProvider from "@/hooks/providers/wavesurfer-provider";

const VocalRemover = () => {
  return (
    <MediaInputProvider
      sessionStorage={vocalRemoverSessionStorage}
      licenseManager={vocalRemoverLicenseManager}
    >
      <VocalRemoverProgressProvider>
        <WavesurferProvider>
          <VocalRemoverPage />
        </WavesurferProvider>
      </VocalRemoverProgressProvider>
    </MediaInputProvider>
  );
};

export default VocalRemover;
